export default "../../src/img/heart-outline.svg";